import ApiService from './api.service'
const ManualService =  {
    GetOrganizationAsSelectList(parentId, authorizedOnly, inspectionOnly){
        return ApiService.get(`/Manual/GetOrganizationAsSelectList?parentId=${parentId}&authorizedOnly=${authorizedOnly}&inspectionOnly=${inspectionOnly}`)
    },
    GetOkedAsSelectList(level){
      return ApiService.get(`/Manual/GetOkedAsSelectList?level=${level}`)
  }
}
export default ManualService